import { OverlayTrigger, Tooltip } from 'react-bootstrap';

// v3_fix_issues.md #3 - a hover/focus tooltip. Use it to wrap a status badge/label that needs
// explaining ("why is the refund held?"), or on its own as a small ⓘ marker next to a heading.
//   <InfoTip text="...">{<Badge>HELD</Badge>}</InfoTip>
//   Rental amount <InfoTip text="Item price x nights" />
let seq = 0;
export default function InfoTip({ text, children, placement = 'top' }) {
  if (!text) return children || null;
  // eslint-disable-next-line no-plusplus
  const id = `tip-${++seq}`;
  return (
    <OverlayTrigger placement={placement} overlay={<Tooltip id={id}>{text}</Tooltip>}>
      {children
        ? <span style={{ cursor: 'help' }} tabIndex={0}>{children}</span>
        : (
          <span
            className="text-muted ms-1"
            style={{ cursor: 'help', fontSize: '0.85em' }}
            tabIndex={0}
            role="img"
            aria-label={text}
          >
            ⓘ
          </span>
        )}
    </OverlayTrigger>
  );
}
